export default __webpack_public_path__ + "static/media/DSC04636.bceca447.jpg";